import { render, staticRenderFns } from "./paymentTest.vue?vue&type=template&id=781c24a5&scoped=true"
import script from "./paymentTest.vue?vue&type=script&lang=js"
export * from "./paymentTest.vue?vue&type=script&lang=js"
import style0 from "./paymentTest.vue?vue&type=style&index=0&id=781c24a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c24a5",
  null
  
)

export default component.exports